

const RoutePath = {
    home: "/",
    //Appointment Paths
    appointmentPage: "/",
    selectServicePage: "/select-service",
    selectSubServicePage: "/select-sub-service",
    selectBranchPage: "/select-branch",
    selectDateAndTimePage: "/select-date-and-time",
    verifyContactDetailsPage: "/verify-contact-details",
    appointmentCompletedPage: "/appointment-completed",
    findYourAppointmentPage: "/find-your-appointment",
    cancelAppointmentPage: "/cancel-appointment",
    appointmentEditCompletedPage: "/appointment-edit-completed",
    cancelAppointmentCompletedPage: "/cancel-appointment-completed",
    //Default
    unknownPage: "*"
}

export {
    RoutePath
}
